import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { IonicModule } from '@ionic/angular'

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';import { IonicStorageModule } from '@ionic/storage-angular';
import {
  LucideAngularModule,
  ArrowUpRight,
  File,
  Home,
  Menu,
  UserCheck,
  FileX,
  CircleX,
  GitCompare,
  Link,
  Link2,
  PackageOpen,
  Users,
  UserRoundCog,
  BookText,
  NotebookPen,
  FolderKanban,
  ListFilter,
  BookX,
  SearchX
} from 'lucide-angular';
import { InterceptorService } from './app/services/_core/interceptor/interceptor.service';
import { SharedModule } from './app/shared/shared.module';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideHttpClient(),
    provideIonicAngular(),
    importProvidersFrom(SharedModule),
    importProvidersFrom(
      LucideAngularModule.pick({
        File,
        FileX,
        Home,
        Menu,
        UserCheck,
        CircleX,
        GitCompare,
        PackageOpen,
        Users,
        UserRoundCog,
        BookText,
        NotebookPen,
        FolderKanban,
        ListFilter,
        BookX,
        SearchX
      })
    ),
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(IonicStorageModule.forRoot()),
    importProvidersFrom(IonicModule),
    provideRouter(routes),
    provideAnimationsAsync(),

    importProvidersFrom(IonicModule)
  ],
});
